/**
 * Pending Withdraw Collection
 */

define(function(require, exports, module) {
    'use strict';

    var server = require('server');
    var PendingWithdrawCollection = require('portlets/cashier/pending/pending.collection');

    module.exports = PendingWithdrawCollection.extend({

        sync: function(method, collection, options) {
            if (method === 'read') {

                var endTime = new Date();
                var startTime = new Date(endTime);
                startTime.setDate(startTime.getDate() - 89);

                var request = {
                    ID: 33026,
                    description: 'Get Transaction History',
                    responses: [33027, 33028],
                    type: 'Withdraw',
                    status: 'Pending',
                    corrections: true,
                    startDate: startTime.toISOString().replace(/\..+/g, '') + 'Z',
                    endDate: endTime.toISOString().replace(/\..+/g, '') + 'Z',
                };

                return server.send(request)
                    .done(options.success).fail(options.error);
            }
        }
    });
});
